<template>
<div>
  <HeaderGestion/>
  <SubHeaderGestion nombreGestion="Postales"/>
  <FormPostales/>
</div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeaderGestion from '../components/SubHeaderGestion.vue'
import FormPostales from '../components/FormPostales.vue'
export default {
  components: { HeaderGestion, SubHeaderGestion, FormPostales },
  name: 'GesPostales'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
